module.exports = __webpack_public_path__ + "static/media/stamp.303886c7.png";